import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'entId', null)

    return {
        data: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'contracts', 'customData', 'data']),
        pagination: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'contracts', 'customData', 'pagination']),
        filter: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'contracts', 'customData', 'filter']),
        sorted: state.getIn(['ui', 'workspace', 'report', id, 'blocks', 'contracts', 'customData', 'sorted']),
        isLoading: state.getIn(
            ['ui', 'workspace', 'report', id, 'blocks', 'contracts', 'customData', 'isLoading'],
            false
        ),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
